import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './guards/auth.guard';
import { HeaderComponent } from './shared/components/header/header.component';
import { httpInterceptProviders } from './http-interceptors/intercept-constants';
import { SpinnerComponent } from './common/spinner/spinner.component';


@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        SpinnerComponent
    ],
    bootstrap: [AppComponent],
    exports: [
        HeaderComponent,
        SpinnerComponent
    ], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule], providers: [AuthGuard, httpInterceptProviders, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
